<template>
  <div>
    <vxe-toolbar size="mini" v-if="!isHiddenBtn">
      <template v-slot:buttons>
        <template>
          <el-button
            type="primary"
            size="small"
            class="vxe-btn-primary"
            @click="introductionFeeHandler"
            >引入明细</el-button
          >
          <el-button
            size="small"
            type="danger"
            class="vxe-btn-delete"
            @click="deleteBtnClickHandler()"
            >删除</el-button
          >
        </template>
      </template>
    </vxe-toolbar>
    <!---可编辑表格-->
    <vxe-grid
      border
      show-overflow
      resizable
      ref="xTableRef"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :edit-rules="tableRules"
      :edit-config="{}"
      :valid-config="{ autoPos: true, message: 'inline' }"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
    >
      <vxe-table-column type="checkbox" width="50"></vxe-table-column>
      <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in tableColumnsList"
        :key="index"
        :type="item.type"
        :fixed="item.fixed"
        :field="item.field"
        :title="item.title"
        :width="item.width"
        :sortable="item.sortable"
        :edit-render="item.editRender"
      >
        <template v-slot="{ row }">
          <template v-if="item.field === 'processStatus'">{{
            row.processStatus == '0' ? '未处理' : '已处理'
          }}</template>
          <template v-else-if="item.field === 'unit'">{{
            dictListMap?.LeaseContractChargeUnit.find((item) => item.value == row['unit'])?.label
          }}</template>
          <template v-else-if="item.field === 'expenseType'">{{
            dictListMap?.LeaseContractExpenseName.find((item) => item.value == row['expenseType'])
              ?.label
          }}</template>
          <template v-else-if="item.field === 'createMethod'">{{
            row['createMethod'] == '01' ? '系统' : '手动'
          }}</template>
          <template v-else-if="item.field === 'spaceType'">{{
            dictListMap?.LeaseContractSpaceType.find((item) => item.value == row['spaceType'])
              ?.label
          }}</template>
          <template v-else-if="item.field === 'spaceCategory'">{{
            dictListMap?.LeaseContractSpaceCategory.find(
              (item) => item.value == row['spaceCategory']
            )?.label
          }}</template>
          <template v-else-if="item.field === 'settlementBusinessType'">{{
            dictListMap?.businessCategoryPayable.find(
              (item) => item.value == row['settlementBusinessType']
            )?.label
          }}</template>
          <template v-else>{{ row[item.field] }}</template>
        </template>
      </vxe-table-column>
    </vxe-grid>
    <!-- 引入费用组件 -->
    <IntroductionCostDialog
      ref="introductionCostDialogRef"
      @confirmHandler="confirmHandler"
      :baseFormData="baseFormData"
    />
  </div>
</template>

<script>
  import { tableColumn } from './index.js';
  import IntroductionCostDialog from './../IntroductionCostDialog/index.vue';
  export default {
    name: 'SettleAccountsDetailTable',
    props: {
      contractStatus: {
        type: String,
        default: '',
      },
      fetchTableData: {
        type: Array,
        default: () => [],
      },
      // 基础表单数据
      baseFormData: {
        type: Object,
        default: () => {},
      },
      // 当前行选中的结算行数据
      currentSettleAccountRowData: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        tableData: [],
        selectionList: [],
        isHiddenBtn: false,
        tableRules: {},
        ids: [], // 被删除的数据id集合
      };
    },
    computed: {
      tableColumnsList() {
        return tableColumn(this);
      },
    },
    mounted() {},
    methods: {
      handleSelectionChange(row) {
        console.log(row, '111');
        this.selectionList = row.selection;
      },
      // 引入费用
      async introductionFeeHandler() {
        console.log('currentSettleAccountRowData', this.currentSettleAccountRowData);
        if (!this.currentSettleAccountRowData.expenseType) {
          this.$message.warning('请先选择结算行费用类型');
          return;
        }
        const { currencyCode, currencyName, exchangeRate, contractNo } = this.baseFormData;
        const { supplierNo, supplierName, productCode, productName, expenseType } =
          this.currentSettleAccountRowData;
        if (!currencyCode || !currencyName || !exchangeRate) {
          this.$message.error('请补充表单数据');
          return;
        }
        console.log(this.baseFormData, '1111111', this.currentSettleAccountRowData);
        const data = {
          contractNo: contractNo,
          supplierNo: supplierNo,
          supplierName: supplierName,
          productCode: productCode,
          productName: productName,
          expenseType: expenseType,
        };
        this.$refs.introductionCostDialogRef.openModal(data, this.tableData);
      },
      // 确认引入费用
      confirmHandler(val) {
        console.log(val, '插入数据');
        // 插入到行明细表中
        this.tableData = [...this.tableData, ...val];
        // 抛出当前表格数据
        this.$emit('confirmChooseDetailHandler', this.tableData);
      },
      // 删除行
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行再删除');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.ids = [...this.ids, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
        this.$emit('confirmChooseDetailHandler', this.tableData);
      },
      // 获取表格数据
      getValidateTableData() {
        return new Promise((resolve) => {
          const $table = this.$refs.xTableRef;
          const tableData = $table.getTableData().fullData;
          $table.validate(() => {
            const currentStatus = this.$route.query.status;
            const formTableData = tableData.map((item) => {
              return {
                ...item,
                departmentCode: this.userInfo.departmentCode,
                departmentName: this.userInfo.departmentName,
                companyCode: this.userInfo.companyCode,
                companyName: this.userInfo.companyName,
                // 特殊处理id
                id:
                  ['create', 'renew'].includes(currentStatus) && this.contractStatus != '01'
                    ? ''
                    : item?.id,
              };
            });
            resolve({ tableData: formTableData, deleteLineDetailIds: this.ids });
          });
        });
      },
      getTableData() {
        const $table = this.$refs.xTableRef;
        return $table.getTableData().fullData;
      },
      fullTableData(tableData) {
        this.tableData = tableData;
      },
    },
    watch: {
      contractStatus: {
        handler(val) {
          // 如果当前是续签的时候只有主体不可以编辑就是
          const currentStatus = this.$route.query.status;
          if (['-1'].includes(val)) {
            this.editConfig = {};
            this.isHiddenBtn = true;
          } else if (['renew', 'change'].includes(currentStatus)) {
            this.editConfig = { trigger: 'click', mode: 'row' };
            this.isHiddenBtn = false;
          } else if (['create'].includes(currentStatus)) {
            // 拷贝的时候
            this.editConfig = { trigger: 'click', mode: 'row' };
            this.isHiddenBtn = false;
          } else {
            if (['02', '03', '05', '06'].includes(val)) {
              this.editConfig = {};
              this.isHiddenBtn = true;
            } else {
              this.editConfig = { trigger: 'click', mode: 'row' };
              this.isHiddenBtn = false;
            }
          }
        },
        immediate: true,
      },
      fetchTableData: {
        handler(val) {
          if (val && val.length) {
            this.fullTableData(val);
          } else {
            this.fullTableData([]);
          }
        },
        immediate: true,
      },
    },
    components: {
      IntroductionCostDialog,
    },
  };
</script>

<style></style>
